<!-- auth-page wrapper -->
<div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
    <div class="bg-overlay"></div>
    <!-- auth-page content -->
    <div class="auth-page-content overflow-hidden pt-lg-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card overflow-hidden">
                        <div class="row g-0">
                            <div class="col-lg-6">
                                <div class="p-lg-5 p-4 auth-one-bg h-100">
                                    <div class="bg-overlay"></div>
                                    <div class="position-relative h-100 d-flex flex-column">
                                        <div class="mb-4">
                                            <a routerLink="" class="d-block">
                                                <img src="assets/images/weber-rescue-systems.png" alt="" height="45">
                                            </a>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>
                            <!-- end col -->
 
                            <div class="col-lg-6">
                                <div class="p-tb-5">
                                    <div>
                                        <h5 class="text-primary">{{"Welcome to user panel" | translate}}</h5>
                                        <p class="text-muted">{{"Sign in to continue to RETTERSeismo" | translate}}</p>
                                    </div>
 
                                    <div class="mt-4">
                                        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                                            <div class="mb-3">
                                                <label class="form-label" for="username">{{"Email/Username" | translate}}</label>
                                                <input type="email" class="form-control" id="email" formControlName="email" [ngClass]="{ 'is-invalid': submitted && f['email'].errors }" placeholder="{{'Enter email or username' | translate}}">
                                                @if (submitted && f['email'].errors) {
                                                <div class="invalid-feedback">
                                                    @if(f['email'].errors['required']){
                                                    <div>{{"Email is required" | translate}}</div>}
                                                    @if(f['email'].errors['email']){
                                                    <div>{{"Email must be a valid email address" | translate}}
                                                    </div>
                                                    }
                                                </div>
                                                }
                                            </div>
                                            <div class="mb-3">
                                                <label class="form-label" for="password-input">{{"Password" | translate}}</label>
                                                <div class="position-relative auth-pass-inputgroup mb-3">
                                                    <input [type]="fieldTextType ? 'text' : 'password'" class="form-control pe-5" placeholder='{{"Enter password" | translate}}' id="password-input" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">
                                                    <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon">
                                                        @if (!(submitted && f['password'].errors)) {
                                                        <i class="mdi align-middle" [ngClass]="{'mdi-eye-off-outline': !fieldTextType, 'mdi-eye-outline': fieldTextType}" (click)="toggleFieldTextType()">
                                                        </i>
                                                        }
                                                    </button>
                                                    @if (submitted && f['password'].errors) {
                                                    <div class="invalid-feedback">
                                                        @if(f['password'].errors['required']){
                                                        <span>{{"Password is required" | translate}}</span>
                                                        }
                                                        @if(f['password'].errors['minlength']){
                                                        <span>{{"Password must be at least 8 characters long" | translate}}</span>
                                                        }
                                                    </div>
                                                    }
                                                </div>
                                            </div>

                                            <div class="mt-4">
                                                <button class="btn btn-dark w-100" type="submit">{{"Login" | translate}}</button>
                                            </div>

                                            <div class="mt-2">
                                                <button class="btn btn-link w-100" type="button" (click)="goToForgotPage()">
                                                  {{ 'Forgot Password' | translate }}
                                                </button>
                                            </div>
                                        </form>
       
                                    </div>
 
                                   
                                </div>
                            </div>
                            <!-- end col -->
                        </div>
                        <!-- end row -->
                    </div>
                    <!-- end card -->
                </div>
                <!-- end col -->
 
            </div>
            <!-- end row -->
            <div class="row">
                <div class="logo-wrap">
                  <div class="logo-img"><a href="#"><img src="assets/images/logos/Retteralarm.png" alt="Retteralarm"></a></div>
                  <div class="logo-img"><a href="#"><img src="assets/images/logos/Retteracademy.png" alt="Retteracademy"></a></div>
                  <div class="logo-img"><a href="#"><img src="assets/images/logos/Retterar.png" alt="Retterar"></a></div>
                  <div class="logo-img"><a href="#"><img src="assets/images/logos/Smart-Force.png" alt="Smart-Force"></a></div>
                  <div class="logo-img"><a href="#"><img src="assets/images/logos/WRAcademy.png" alt="WRAcademy"></a></div>
                  <div class="logo-img"><a href="#"><img src="assets/images/logos/Retterseismo.png" alt="Retterseismo"></a></div>
                </div>
              </div>
        </div>
        <!-- end container -->
    </div>
    <!-- end auth page content -->
 
    <!-- footer -->
    <footer class="footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-center">
                        <p class="mb-0">Copyright &copy; {{2025}} RETTERSeismo</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- end Footer -->
</div>
<!-- end auth-page-wrapper -->